import { type CoreUserAddressResponseList } from '@flecto/types'

import { api } from '../../../services/api'

/**
 * Get all user logged addresses.
 *
 * @endpoint GET /api/me/addresses
 * @scope shared
 * @see https://flecto.dev/api-4724191
 */
export async function getAllUserAddresses(): Promise<CoreUserAddressResponseList> {
  const response =
    await api.get<CoreUserAddressResponseList>('/api/me/addresses')

  return response.data
}
